module.exports = __webpack_public_path__ + "static/media/GPRlogoBlack.0cab1768.png";